import { DEFAULT_TEMPLATES } from "./defaultTemplates";

const googleReviewLink = "https://g.page/r/CaRN2MafhhxpEB0/review";
const reviewText = `If you are satisfied with our work we would appreciate it if you could leave us a <a href='${googleReviewLink}'>review</a>!\n\n\n`;
const signOff = `**Peter**\n^^All electrical work carried out by **HES** fully complies to current IET **BS7671**:2018/A4:2026 regulations.^^`;

// Substitutes {{key}} placeholders with values from vars, leaving unknown placeholders
// blank rather than throwing - a template referencing a variable this email type doesn't
// provide (e.g. {{amount}} on a Quote) should degrade quietly, not crash draft creation.
export function renderTemplate(text, vars = {}) {
  if (!text) return "";
  return text.replace(/{{\s*(\w+)\s*}}/g, (_, key) => {
    let value = vars[key];
    return value === undefined || value === null ? "" : value;
  });
}

export function buildTemplateVars({ name, refNumber, amount, addressLine, jobDetails, showReview }) {
  return {
    name,
    refNumber,
    amount,
    addressLine,
    jobDetails,
    reviewText: showReview ? reviewText : "",
    signOff,
  };
}

// Firestore override (if any) wins, otherwise fall back to the built-in default copy -
// this is the one place both getPdfEmailText (real draft creation) and the Templates
// settings page (editor) should resolve a template's raw source text from, so they can
// never drift out of sync with each other.
export function getTemplateMessage(templateKey, templatesMap = {}) {
  if (templatesMap[templateKey]?.message !== undefined) {
    return templatesMap[templateKey].message;
  }

  // Invoice/Paid templates only just gained vat_on/vat_off variants - before that, both
  // vat modes shared one template under the plain (unsuffixed) key. Fall back to whatever
  // was saved there so an existing customization isn't silently dropped the first time
  // either new variant is opened. Once someone edits+saves a __vat_on/__vat_off card
  // directly, it gets its own override and this fallback no longer applies to it.
  let legacyKey = templateKey.replace(/__vat_(on|off)$/, "");
  if (legacyKey !== templateKey && templatesMap[legacyKey]?.message !== undefined) {
    return templatesMap[legacyKey].message;
  }

  return DEFAULT_TEMPLATES[templateKey] ?? "";
}
